import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react"
import CirculerLoader from "../../components/Loader";
// import { SchoolSignupContext } from "../../context/SchoolSignupContext";
// import { useContext } from "react";
const VerificationPage: React.FC = () => {
const [code, setCode] = useState<any>("");
const [errorMsg, setErrorMsg] = useState("");
const [loading, setLoading] = useState(false);
const [error, setError] = useState(false);
  const navigate =  useNavigate();
  const location = useLocation(); 
  const email = location.state?.email;
  const baseURL = process.env.REACT_APP_BASE_URL;

useEffect(()=>{
  if(location.state?.Code){
  setCode(Number(location.state?.Code));
  }else{
    setCode("")
  }
}, [location.state?.Code])


const goToProfile = async () => {

if(code === ""){
  setErrorMsg("The verification code is required");
}
else{
try {
  setLoading(true)
      const response = await axios.post(`${baseURL}/user/verifyOTP`, {
        email: email,
        code: code.toString()
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      setLoading(false)
      if(response.data.code !== 400){
        localStorage.setItem("access_token", response.data?.data);
              navigate("/profile", { state: { email } });
            }else{
              setError(true)
            }

    } catch (error) {
      setLoading(false)
      // console.error('Error creating user:', error.response ? error.response.data : error.message);
    }
  }
  };
  
  const ResendCode = async () => {
    try {
      setLoading(true)
      const response = await axios.post(`${baseURL}/user/resentOTP`, {
        email: email
      },
       {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      alert("Message sent successfully.")
    } catch (error) {
      setLoading(false)
      // console.error('Error creating user:', error.response ? error.response.data : error.message);
    }
  };
  

    return (
      <div className="verifaction-inner-part">
        {loading && <CirculerLoader/>}
                {email ? 
        <div className="verification-content">
          <h2 className="verification-h2">Check your inbox</h2>
          <p className="verifaication-para">
            Enter the verification code we just sent to {email}.
          </p>
          
          <div className="verifaction-inner-input">
            {/* <input
              type="text"
              placeholder="Code"
              onChange={(e)=>{setCode(e.target.value)}}
            /> */}
            <div className="input-container input-containers">
             
             <input
              type="text"
                placeholder=" "
                value={code}
                maxLength={6}
                onChange={(e)=>{setCode(e.target.value)}}
           />
             <label >Code</label>
             {code=== "" ? <p style={{color:"red"}}>{errorMsg}</p>:
           code.length < 6 ?  <p style={{color:"red"}}> 
           The verification code should be exactly 6 characters long </p>: error ?
            <p style={{color:"red"}}>Invalid code </p>: ""}
         </div>
         
            <button className="continue-btn" onClick = {goToProfile}>
              Continue
            </button>
            <button className="resend-btn"  onClick = {ResendCode}>
              Resend email
            </button>
          </div>
          
          <p className="terms-inner">
            <a href="#">Terms of Use</a>  |  <a href="#">Privacy Policy</a>
          </p>
        </div>
             : "Oops email missing for verification"}
      </div>
    );
  }
  export default VerificationPage;